import React, { useState } from "react";

import { getVideoChapterByCurrentTime } from "./getVideoChapterByCurrentTime";

import type { VideoData } from "../types";

export const useGetCurrentChapterNameForLive = (video: VideoData): string => {
  /**
   * TODO: realtime databaseを用いて正確な現在時刻を取得できるようにする
   */
  const currentTime = new Date().getTime();
  const [currentChapterName, setCurrentChapterName] = useState<
    string | undefined
  >(getVideoChapterByCurrentTime(video.chapters, currentTime)?.name);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      /**
       * TODO: realtime databaseを用いて正確な現在時刻を取得できるようにする
       */
      const currentTime = new Date().getTime();
      const newChapterName = getVideoChapterByCurrentTime(
        video.chapters,
        currentTime
      )?.name;
      setCurrentChapterName(newChapterName);
    }, 2000); // 2秒ごとに更新

    return () => clearInterval(intervalId);
  }, [video.chapters, video.name]);

  return currentChapterName ?? video.name;
};
